export default {
  'order': {
    'title': 'Send Inquiry',
    'subTitle': 'Exhibitors will receive your intended order and contact you for negotiation',
    'number': 'Fill in the quantity',
    'remarks': 'Remark',
    'numberPlaceholder': 'Please enter the purchase quantity',
    'remarksPlaceholder': 'Please enter what you would like to know',
    'all order': 'All Order',
    'my order': 'My Order',
    'all': 'All orders',
    'not assigned': 'Not assigned ({0})',
    'me': 'Me',
    'already assigned': 'Already assigned ({0})',
    'Cancel': 'Cancel',
    'Confirm': 'Confirm',
    'Potential Order Management': 'Wish list management'
  },
  'Chat': 'Chat',
  'Amount purchased': 'Purchase quantity',
  'Potential Amount purchased': 'Quantity of intentional purchase: {0}',
  'Action': 'Operation',
  'Follow up person': 'Personnel of follow up',
  'Potential Order': 'Intent order',
  'Order Completed': 'Contacted',
  'Not completed yet': 'Not Contacted yet',
  'Order time': 'Order time',
  'Search by exibitor name, exibits': 'Search by exhibitor and exhibit name',
  'Results are shown by Beijing Time (GMT+8)': '	The following is shown as Beijing time.（GMT+8）',
  'Are you sure you want to delete this order?': 'Are you sure to delete this order?',
  'Assign salesman': 'Assign a salesperson.',
  'You can chat with potential customer by assigning salesman, managing your potential order': 'The assigned salesperson can communicate with the audience of the order intention and manage the intention order',
  'Enter salesman name for searching': 'Enter the name of the salesperson and search',
  'Assign employee': 'Assign personnel',
  'Salesman not assigned': 'Unassigned personnel',
  'Salesman already assigned': 'Assigned personnel',
  'You selected': 'You have chosen',
  'Potential order detail': 'Details of intention order',
  'Record the data and status for the current order detail': 'Record the detailed data information and status of the current order',
  'Submit potential order successfully': 'Intention order submitted successfully',
  'Exhibitor\'s Salesman': 'Employee of Exhibitors',
  'Not assigned yet': 'Not assigned yet',
  'Delete potential order successfully': 'Order deleted successfully',
  'Complete order': 'The order is completed.',
  'Wish Product': 'Interested exhibits',
  'Wish Exhibitor': 'Interested exhibitors',
  'Order Employee': 'Employee'

}